import React from 'react'
import { Segment, Icon, Grid, Header } from 'semantic-ui-react'
import { onWhatsClick } from './../js'
import colors from '../js/colors'

export default ({ buttonType }) => {
  return (
    <div>
      <Segment onClick={buttonType ? '' : () => onWhatsClick()} style={{ cursor: buttonType ? '' : 'pointer' }}>
        {buttonType ? <GridButton /> : <GridWhats />}
      </Segment>
    </div>
  )
}

const GridButton = () => (
  <Grid relaxed>
    <Grid.Row columns="equal" verticalAlign="middle" textAlign="center">
      <Grid.Column>
        <Header inverted as="h3" color="orange">
          <Icon name="pencil" size="big" color="orange" />
          Solicite seu Orçamento
        </Header>
      </Grid.Column>
    </Grid.Row>
  </Grid>
)

const GridWhats = () => (
  <Grid inverted stackable style={{ backgroundColor: colors.light }}>
    <Grid.Row columns="equal" verticalAlign="middle" textAlign="center">
      <Grid.Column>
        <h3 style={{ color: colors.mediumDark }}>
          {/* <Icon name="whatsapp" size="big" color="orange" /> */}
          Nosso What's
        </h3>
        <h4 style={{ color: colors.mediumDark }}>Clique agora e solicite seu orçamento!</h4>
      </Grid.Column>
    </Grid.Row>
    <Grid.Row columns="equal" textAlign="center">
      <Grid.Column>
        <h2 style={{ color: colors.mediumDark }}>{'(11) 9 9919-8944 '}</h2>
      </Grid.Column>
    </Grid.Row>
  </Grid>
)
